<div>
  <div>
    <div>{{ 'MENU.ALLERGEN_GROUP.FIELD_NAME' | translate }}</div>

    <mat-chip-list class="tags-chip-list" aria-label="Tags selection">
      <mat-chip *ngFor="let allergenGroupId of allergenGroupIdSet"
                [removable]="true"
                (click)="onOpenAllergenGroup(allergenGroupId)">
        {{ getAllergenName(allergenGroupId) }}
        <button
          matChipRemove
          *ngIf="allowOverrides && isManuallyCreated(allergenGroupId)"
          (click)="onDeleteAllergenGroup(allergenGroupId)">
          <mat-icon>delete</mat-icon>
        </button>
        <button
          *ngIf="allowOverrides"
          matChipRemove
          (click)="onRemoveAllergenGroupFromProduct(allergenGroupId)">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list>

    <div *ngIf="allowOverrides" >
      <mat-form-field>
        <mat-select placeholder="{{ 'MENU.ALLERGEN_GROUP.PLACEHOLDER' | translate }}">
          <mat-option *ngFor="let allergenGroup of allergenGroups">
            <div class="option-container">
              <p class="item1" (click)="onAllergenGroupPicked(allergenGroup?.id)">
                {{ allergenGroup?.name }}
              </p>
              <p class="item2">
                <button *ngIf="allowOverrides && isManuallyCreated(allergenGroup.id)" (click)="onDeleteAllergenGroup(allergenGroup.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </p>
              <p class="item3">
                <button *ngIf="allowOverrides" (click)="onOpenAllergenGroup(allergenGroup.id)">
                  <mat-icon>edit</mat-icon>
                </button>
              </p>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-icon
        *ngIf="allowOverrides"
        mat-icon-button
        matTooltip="{{'MENU.ALLERGEN_GROUP.CREATE' | translate}}"
        class="size-scale-edit-button"
        (click)="onOpenAllergenGroup()">add_box
      </mat-icon>
    </div>
  </div>
</div>
